import { StoreEnum } from '@portal/schema/storeCode';
import { useMemo } from 'react';
import { useStoreValue } from './useStore';

export function useIsStore() {
  const store = useStoreValue();

  const isUsStore = useMemo(
    () => [StoreEnum.us, StoreEnum.qa, StoreEnum.dev].includes(store),
    [store]
  );
  const isEuStore = useMemo(() => [StoreEnum.eu, StoreEnum.eud].includes(store), [store]);
  const isUkStore = useMemo(() => [StoreEnum.uk, StoreEnum.ukd].includes(store), [store]);
  const isAuStore = useMemo(() => [StoreEnum.au, StoreEnum.aud].includes(store), [store]);
  const isNzStore = useMemo(() => [StoreEnum.nz, StoreEnum.nzd].includes(store), [store]);
  const isJpStore = useMemo(() => [StoreEnum.jp].includes(store), [store]);

  return {
    isUsStore,
    isEuStore,
    isUkStore,
    isAuStore,
    isNzStore,
    isJpStore
  };
}
